module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": _vm.name
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ed4605c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chartjs/Pie.vue
// module id = 2251
// module chunks = 0